module.exports = __webpack_public_path__ + "img/isaac.7ab6c341.jpeg";